import { ColumnDef } from "@tanstack/react-table";
import { displayCountOrDash } from "@/core/utils/number";

interface WithSpiffCounts {
  pricebook_item_sale_count: number;
}

const PricebookSalesCol = <T extends WithSpiffCounts>(): ColumnDef<T> => ({
  header: "Pricebook Sales",
  accessorFn: (row) => row.pricebook_item_sale_count,
  cell: ({ getValue }) => displayCountOrDash(getValue() as number),
});

export default PricebookSalesCol;
